<template>
  <div>
    <div>
      <nav-bar :title="title"></nav-bar>
    </div>
    <div class="content">
      <div v-html="page.pInfo"></div>
    </div>
    <!-- 页脚 -->
    <page-footer></page-footer>
  </div>
</template>

<script>
export default {
  data() {
    return { title: '', pageId: '', page: [] }
  },
  created() {
    var query = this.$route.query
    if (query.pageId) {
      this.pageId = query.pageId
    }

    var name = this.$route.name
    var menuList = JSON.parse(window.sessionStorage.getItem('menuList'))
    var index = menuList.findIndex(item => item.cCode == name)
    this.title = menuList[index].menuName
    // 获取页面内容
    this.getPageDetail()
  },
  methods: {
    async getPageDetail() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/customPage/pageDetail?pageId=' + this.pageId)
      if (data.success) {
        this.page = data.data.page
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$app-height: 100vh;
.content {
  min-height: $app-height;
  padding: 10px 5%;
  background-color: #fafafa;
  overflow: hidden;
}
</style>
